import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import { ChevronRight, RefreshCw, Shield, Trophy } from 'lucide-react';
import React from 'react';

export const RefreshPerformanceStatsBoost = (): JSX.Element => {
  return (
    <Card className="border-grey-2 bg-grey-0 w-full rounded-2xl border border-solid">
      <CardContent className="p-4">
        <div className="flex w-full items-start gap-4">
          <div className="bg-teal-4 flex h-[54px] w-[54px] items-center justify-center rounded-2xl">
            {/* Money bag icon */}
            <div className="text-grey-0 flex h-6 w-6 items-center justify-center">
              <Shield className="h-6 w-6" />
            </div>
          </div>
          <div className="flex flex-1 flex-col items-start justify-center gap-2">
            <div className="flex w-full flex-col items-start">
              <div className="flex w-full items-center justify-between">
                <div className="text-grey-6 font-medium">
                  Get $50 cash reward
                </div>
                <ChevronRight className="text-gravyfa6-navy h-[18px] w-[18px]" />
              </div>
              <div className="inline-flex items-center gap-1">
                <div className="text-grey-5 whitespace-nowrap text-xs">
                  Reward when single order value &gt;= $1,000
                </div>
                <RefreshCw className="text-grey-3 h-3 w-3" />
              </div>
            </div>
            <div className="flex w-full items-center justify-between rounded-lg">
              <div className="inline-flex items-center gap-1">
                <div className="inline-flex items-center justify-center gap-1 rounded-lg">
                  <Trophy className="text-yellow-5 h-3 w-3" />
                  <div className="text-grey-6 whitespace-nowrap text-xs">
                    Awarded 1 times
                  </div>
                </div>
              </div>
              <div className="rounded-lg px-1 py-1.5" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
export default RefreshPerformanceStatsBoost;
